import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private readonly httpClient: HttpClient) { }

  getCompanyData(dbName: string): Observable<any> {
    return this.httpClient.get(environment.apiEndpoint + 'company?databaseName=' + dbName);
  }

  updateCompanyData(body: any): Observable<any> {
    return this.httpClient.put(environment.apiEndpoint + 'company', body);
  }
}
